/* tslint:disable */
/* eslint-disable */
/**
 * e-SNRWB
 * Opis api e-SNRWB
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateUpdateTechAssessmentDto
 */
export interface CreateUpdateTechAssessmentDto {
    /**
     * 
     * @type {Date}
     * @memberof CreateUpdateTechAssessmentDto
     */
    date?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof CreateUpdateTechAssessmentDto
     */
    preparationDate?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateTechAssessmentDto
     */
    organizationalUnitId: string;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateTechAssessmentDto
     */
    number: string;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateTechAssessmentDto
     */
    productName: string;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateTechAssessmentDto
     */
    producerId: string;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateTechAssessmentDto
     */
    productType: string;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateTechAssessmentDto
     */
    productPurpose: string;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateTechAssessmentDto
     */
    groupProductTypeId: string;
    /**
     * 
     * @type {Date}
     * @memberof CreateUpdateTechAssessmentDto
     */
    expDateStart?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof CreateUpdateTechAssessmentDto
     */
    expDateEnd?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof CreateUpdateTechAssessmentDto
     */
    repealDate?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateTechAssessmentDto
     */
    note: string;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateTechAssessmentDto
     */
    groupProductTypeOther: string;
}

export function CreateUpdateTechAssessmentDtoFromJSON(json: any): CreateUpdateTechAssessmentDto {
    return CreateUpdateTechAssessmentDtoFromJSONTyped(json, false);
}

export function CreateUpdateTechAssessmentDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateUpdateTechAssessmentDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'date': !exists(json, 'date') ? undefined : (json['date'] === null ? null : new Date(json['date'])),
        'preparationDate': !exists(json, 'preparationDate') ? undefined : (json['preparationDate'] === null ? null : new Date(json['preparationDate'])),
        'organizationalUnitId': json['organizationalUnitId'],
        'number': json['number'],
        'productName': json['productName'],
        'producerId': json['producerId'],
        'productType': json['productType'],
        'productPurpose': json['productPurpose'],
        'groupProductTypeId': json['groupProductTypeId'],
        'expDateStart': !exists(json, 'expDateStart') ? undefined : (json['expDateStart'] === null ? null : new Date(json['expDateStart'])),
        'expDateEnd': !exists(json, 'expDateEnd') ? undefined : (json['expDateEnd'] === null ? null : new Date(json['expDateEnd'])),
        'repealDate': !exists(json, 'repealDate') ? undefined : (json['repealDate'] === null ? null : new Date(json['repealDate'])),
        'note': json['note'],
        'groupProductTypeOther': json['groupProductTypeOther'],
    };
}

export function CreateUpdateTechAssessmentDtoToJSON(value?: CreateUpdateTechAssessmentDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'date': value.date === undefined ? undefined : (value.date === null ? null : value.date.toISOString()),
        'preparationDate': value.preparationDate === undefined ? undefined : (value.preparationDate === null ? null : value.preparationDate.toISOString()),
        'organizationalUnitId': value.organizationalUnitId,
        'number': value.number,
        'productName': value.productName,
        'producerId': value.producerId,
        'productType': value.productType,
        'productPurpose': value.productPurpose,
        'groupProductTypeId': value.groupProductTypeId,
        'expDateStart': value.expDateStart === undefined ? undefined : (value.expDateStart === null ? null : value.expDateStart.toISOString()),
        'expDateEnd': value.expDateEnd === undefined ? undefined : (value.expDateEnd === null ? null : value.expDateEnd.toISOString()),
        'repealDate': value.repealDate === undefined ? undefined : (value.repealDate === null ? null : value.repealDate.toISOString()),
        'note': value.note,
        'groupProductTypeOther': value.groupProductTypeOther,
    };
}


